var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-wrapper',{attrs:{"title-translation-path":"admin.EVENTS_LOG","has-buttons":false,"inputs":_vm.inputs},scopedSlots:_vm._u([{key:"table.input",fn:function(){return [_c('events-log-tab')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }